import { render } from "./BottomBar.vue?vue&type=template&id=0d1db9ca&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=0d1db9ca&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1db9ca"]])

export default __exports__